<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 xl:gap-16 px-4 lg:px-0">
        <template v-if="categories.length > 0">
            <template v-for="category in categories">
                <template v-for="theme in category.themes">
                    <CategoryCard :key="theme.id" :category="theme" />
                </template>
            </template>
        </template>
        <template v-else>
            <div v-for="n in 9" :key="n" class="h-48 bg-white rounded-lg shadow-md overflow-hidden">
                <div class="h-full bg-white animate-pulse flex items-center justify-center">
                    <div class="h-6 w-full mx-12 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CategoryCard from './CategoryCard.vue';
export default {
    components: { CategoryCard },
    data() {
        return {
            categories: []
        };
    },

    mounted() {
        this.fetchCategories();
    },

    methods: {
        fetchCategories() {
            fetch(`${process.env.MIX_RUMIE_BASE_URL}/api/v3/learn/projects/1/category/career-skills/themes`)
                .then(response => response.json())
                .then(response => {
                    this.categories = response.topics;
                });
        }
    }
};
</script>
